export default {
  'menu.account': 'Account',
  'menu.account.center': 'Profile',
  'menu.dashboard': 'Dashboard',
  'menu.devices': 'Devices',
  'menu.devices.list': 'Device List',
  'menu.addressBook': 'Address Books',
  'menu.addressBook.personal': 'Personal',
  'menu.addressBook.shared': 'Shared',
  'menu.deviceGroups': 'Device Groups',
  'menu.deviceGroups.list': 'Device Groups',
  'menu.users': 'Users',
  'menu.audits': 'Audit Logs',
  'menu.audits.conn': 'Connection',
  'menu.audits.file': 'File Transfer',
  'menu.audits.alarm': 'Alarm',
  'menu.audits.console': 'Console',
  'menu.login': 'Login',
  'menu.roles': 'Roles',
  'menu.strategies': 'Strategies',
  'menu.groups': 'Groups',
  'menu.groups.user': 'User Groups',
  'menu.groups.device': 'Device Groups',
  'menu.settings': 'Settings',
  'menu.settings.general': 'General Settings',
  'menu.settings.smtp': 'SMTP Configuration',
  'menu.settings.oidcProviders': 'OIDC Providers',
  'menu.settings.ldap': 'LDAP Configuration',
  'menu.customClients': 'Custom Clients',
  'menu.addressBooks': 'Address Books',
  'menu.list.audit-list': 'Audit List',
  'menu.list.audit-list.File': 'File Transfer',
  'menu.list.audit-list.Connection': 'Connection',
  'menu.list.audit-list.Alarm': 'Alarm',
};
